import { render, staticRenderFns } from "./ConfigConvenienciaEditar.vue?vue&type=template&id=2290b996&scoped=true&"
import script from "./ConfigConvenienciaEditar.vue?vue&type=script&lang=js&"
export * from "./ConfigConvenienciaEditar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigConvenienciaEditar.vue?vue&type=style&index=0&id=2290b996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290b996",
  null
  
)

export default component.exports